// extracted by mini-css-extract-plugin
module.exports = {"container":"v_header_container__2AyTa","button":"v_header_button__1ZGBc"};